'use strict'

import $ from 'jquery';
import Highcharts from 'highcharts/highstock';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import { chartLib } from '../../common/ChartLibrary';

NoDataToDisplay(Highcharts);

/**
 * 銘柄比較 - 株価指数 - PBR グラフ生成クラス
 *
 * @param {string} divId グラフ出力先の<div>タグのID
 * @param {string} jsonList データファイルJSON
 * @param {object} stockCdList 銘柄コードリストJSON
 * @param {object} stockNameList 銘柄名リストJSON
 * @param {object} latestIndexList グラフ存在フラグJSON
 */
const ComparisonIndexPbrClass = function(divId, jsonList, stockCdList, stockNameList, latestIndexList) {
    try {
        let jsonData = [],    // データ用JSON
            graphColorList = [],
            tmpJsonList = [],

        //銘柄件数取得
            stockCdLength = stockCdList.length,
            json;

        //グラフ色の設定
        graphColorList[0] = '#11ab79';
        graphColorList[1] = '#1196e3';
        graphColorList[2] = '#722897';
        graphColorList[3] = '#f6107c';
        graphColorList[4] = '#fb7011';
        graphColorList[5] = '#f2d81f';

        //銘柄分JSONを取得する
        $.each(stockCdList, function(idx, stockCd) {
            //グラフJSONが無い銘柄は読み込まない
            if (latestIndexList[stockCd].PBR !== null) {

                json = jsonList[stockCd];

                //JSONデータを書き換え PBR
                json[3].name = stockNameList[stockCd];
                json[3].color = graphColorList[idx];
                tmpJsonList[idx] = json[3];

            } else {
                //比較対象件数を減らす
                --stockCdLength;
            }

            //0件ならエラーメッセージを表示
            if (stockCdLength <= 0) {
                $(function() {
                    showDataEmptyMsg();
                });

            } else {

                //全てのJSONを取得したらデータ処理
                if (Object.keys(tmpJsonList).length === stockCdLength) {
                    //配列に抜けがある時、エラーになるので詰める
                    $.each(tmpJsonList, function(idx, data) {
                        if (data !== undefined && data !== null && data !== '') {
                            jsonData.push(data);
                        }
                    });
                    // グラフの生成
                    // 説明：・設定用JSONP・データ用JSONPを使用して、グラフの設定を行う
                    createGraph(divId, jsonData);
                }
            }
        });
        // +++++++++++++++++++++++++++++++++
    } catch (e) {
        console.log(e);
    }

    function showDataEmptyMsg() {
        $('.pbr.data_empty').show();
    }

    /**
     * グラフを生成
     * @param {string} divId - グラフ出力先の<div>タグのID
     * @param {object} jsonData - jsonデータ
     */
    function createGraph(divId, jsonData) {
        //不要な過去データを削る用カウント
        let cnt = 0,
            currentTime = Math.floor(Date.now() / 1000), // 現在のUNIXタイムスタンプ
            twoYearsAgo = currentTime - (2 * 365 * 24 * 60 * 60); // 2年前のUNIXタイムスタンプ
        $.each(jsonData[0].data, function(idx, graphData) {
            if (graphData[0].toString().slice(0, -3) >= twoYearsAgo) {
                cnt++;
            }
        });
        //2年ボタン表示用の補正
        cnt = cnt + 5;
        //不要な過去データを削る
        $.each(jsonData, function(idx, graphData) {
            jsonData[idx].data = graphData.data.slice(-cnt);
        });

        Highcharts.setOptions({
            lang: {
                // 縦軸の数値にカンマ表示
                thousandsSep: ',',
                rangeSelectorZoom: '',
                // 表示データが無い時のメッセージ
                noData: '選択されているデータはありません',
            },
            // 表示をUTCからローカルタイムにする
            global: {
                useUTC: false
            }
        });

        //チェックボックスを凡例の左側に配置する
        moveCheckboxToLeftOfLegend();

        Highcharts.chart(divId,{
            chart: {
                style: {
                    fontFamily: $('#fontFamily').val()
                },
                events: {
                    //チャート読み込み後の処理
                    load: function() {
                        //チェックボックス押下時の処理
                        $('#' + divId + ' :checkbox').on('click', function() {
                            if ($(this).attr('checked') === 'checked') {
                                $(this).attr('checked', false);
                                $(this).prop('checked', false);
                            } else {
                                $(this).attr('checked', true);
                                $(this).prop('checked', true);
                            }
                        });
                    }
                }
            },
            title: {
                text: null
            },
            //折れ線グラフのナビゲーション表示設定
            navigator: {
                enabled: true,
                height: 25, //default:40
                margin: 10,
                xAxis: {
                    type: 'datetime',
                    tickPosition: 'inside',
                    labels: {
                        format: '{value:%y/%m}',
                        style: {
                            color: '#000'
                        }
                    },
                    lineWidth: 0,
                    tickWidth: 0,
                    crosshair: true, //マウスホバーした時の縦線表示設定
                    tickInterval: 3600 * 24 * 30 * 6 * 1000 //半年
                },
                series: {
                    color: '#fff',
                    lineWidth: 0
                }
            },
            scrollbar: {
                enabled: true,
                liveRedraw: true,
                height: 10
            },
            rangeSelector: {
                enabled: true, //ボタン
                inputEnabled: false, //期間入力欄
                buttons: [
                    {
                        type: 'year',
                        count: 1,
                        text: '1年'
                    }, {
                        type: 'year',
                        count: 2,
                        text: '2年'
                    }, {
                        type: 'year',
                        count: 3,
                        text: '3年',
                    }, {
                        type: 'year',
                        count: 4,
                        text: '全て'
                    }
                ],
                buttonTheme: {
                    fill: 'none',
                    stroke: 'none',
                    width: 40,
                    style: {
                        color: '#039',
                        fontWeight: 'normal'
                    },
                    states: {
                        hover: {
                            fill: '#e1c561'
                        },
                        select: {
                            fill: '#ffd833',
                            style: {
                                color: '#000'
                            }
                        }
                    }
                },
                selected: 1
            },
            //横軸
            xAxis: {
                title: {
                    text: null
                },
                type: 'datetime',
                dateTimeLabelFormats: {
                    day: '%y/%m/%d',
                    week: '%y/%m/%d',
                    month: '%y/%m',
                    year: '%Y'
                },
                tickmarkPlacement: 'on', //目盛線の位置 between,on
                tickPosition: 'outside', //目盛線の表示場所 inside:内側 outside:外側
                minPadding: 0, //グラフの両脇の空白を削除
                maxPadding: 0,
                minTickInterval: 60*60*24*7*1000,
                labels: {
                    style: {
                        color: '#000'
                    }
                },
                crosshair: {
                    width: 2,
                    zIndex: 5
                }
            },
            //縦軸
            yAxis: {
                title: {
                    text: null
                },
                labels: {
                    format: '{value:.,0f}', //ラベルのフォーマット設定
                    style: {
                        color: '#000'
                    }
                },
                //縦軸補助線の設定
                gridLineColor: '#c3c3c3',
                gridLineWidth: 1,
                gridLineDashStyle: 'solid', //縦軸線スタイル dash:点線 solid:線
                //縦軸ラベル横の線の設定
                lineWidth: 1,
                lineColor: '#c3c3c3',
                //縦軸補助線の設定
                tickLength: 5,
                tickWidth: 1,
                tickColor: '#c3c3c3',
                crosshair: {
                    width: 2,
                    zIndex: 5
                },
                tickPositioner: function () {
                    //tick値を計算する
                    return chartLib.calcTickPositions(this, 7);
                }
            },
            //マウスホバー時の設定
            tooltip: {
                xDateFormat: '%Y/%m/%d',
                style: {
                    fontSize: '11px'
                },
                hideDelay: 100, //マウスを外してからtooltipが消えるまでの時間
                shared: true, //縦列グループ化
                useHTML: true,
                positioner: function(boxWidth, boxHeight, point) {
                    return chartLib.tooltipPositioner(this, boxWidth, boxHeight, point);
                },
                formatter: function() {
                    let tooltip = '<table>',
                        symbolColor,
                    //単位
                        suffix = ' 倍',
                    //小数点表示桁数
                        digit = 2,
                    //シンボル
                        symbol = '●',
                    //スタイル設定
                        numStyle = 'font-weight: bold; text-align: right;';

                    tooltip += '<tr><td colspan="2">' + Highcharts.dateFormat('%Y/%m/%d', new Date(this.x)) + '</td></tr>';
                    $.each(this.points, function() {
                        symbolColor = this.series.color;
                        //置換文字を置換し、文字列結合
                        tooltip += '<tr>';
                        tooltip += '<td><span style="color:' + symbolColor + '">' + symbol + '</span> ' + this.series.name + ':</td>';
                        tooltip += '<td style="' + numStyle + '">&nbsp;' + Highcharts.numberFormat(this.y, digit, '.', ',') + suffix + '</td>';
                        tooltip += '</tr>';
                    });
                    tooltip += '</table>';
                    return tooltip;
                }
            },
            //凡例
            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'middle',
                borderWidth: 0
            },
            exporting: false,
            credits: false, //右下公式クレジット表示設定
            plotOptions: {
                line: {
                    yAxis: 0,
                    animation: false,
                    color: '#c0504d',
                    lineWidth: 1,
                    //折れ線グラフ点表示設定
                    marker: {
                        enabled: false
                    }
                },
                series: {
                    showCheckbox: true,
                    selected: true,
                    marker: {
                        radius: 2
                    },
                    events: {
                        //チェックボックスが押されたとき、凡例をON/OFFする
                        checkboxClick: function(event) {
                            //this要素を退避させる
                            let $this = this;
                            //先にcheckbox.clickイベントを処理させるため、ディレイさせる
                            setTimeout(function() {
                                if ($($this.checkbox).prop('checked')) {
                                    $this.show();
                                } else {
                                    $this.hide();
                                }
                            }, 20);
                            //表示中グラフが無い時、文言を表示する
                            chartLib.checkGraphNoData(divId);
                        },
                        //凡例が押されたとき、チェックボックスをON/OFFする
                        legendItemClick: function(event) {
                            if ($(this.checkbox).attr('checked') === 'checked') {
                                $(this.checkbox).attr('checked', false);
                                $(this.checkbox).prop('checked', false);
                            } else {
                                $(this.checkbox).attr('checked', true);
                                $(this.checkbox).prop('checked', true);
                            }
                            //表示中グラフが無い時、文言を表示する
                            chartLib.checkGraphNoData(divId);
                        }
                    },
                    states: {
                        inactive: {
                            //ホバーイベントのデフォルトを薄くしない（以前と同じに）
                            opacity: 1,
                        }
                    }
                }
            },
            //データ
            series: jsonData
        });
    }

    /**
     * チェックボックスを凡例の左側へ移動させる
     */
    function moveCheckboxToLeftOfLegend() {
        let alignAttr,
            clipHeight,
            translateY,
            checkbox,
            bBox,
            top;
        Highcharts.wrap(Highcharts.Legend.prototype, 'positionCheckboxes', function(p, scrollOffset) {
            alignAttr = this.group.alignAttr;
            clipHeight = this.clipHeight || this.legendHeight;
            if (alignAttr) {
                translateY = alignAttr.translateY;
                Highcharts.each(this.allItems, function(item) {
                    checkbox = item.checkbox;
                    bBox = item.legendItem.getBBox(true);
                    if (checkbox) {
                        top = (translateY + checkbox.y + (scrollOffset || 0) + 5);
                        Highcharts.css(checkbox, {
                            left: (alignAttr.translateX + item.checkboxOffset + checkbox.x - 57 - bBox.width) + 'px',
                            top: top + 'px',
                            display: top > translateY - 6 && top < translateY + clipHeight - 6 ? '' : 'none'
                        });
                    }
                });
            }
        });
    }
};

export { ComparisonIndexPbrClass };
